var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.activation && _vm.activationChecked)?_c('div',{staticClass:"text-center mt-5"},[_c('b-button',{attrs:{"href":"#","variant":"cta"},on:{"click":function($event){return _vm.$router.push('/login')}}},[_vm._v(_vm._s(_vm.$t('BACK_TO_LOGIN')))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }